import { FileText, BookOpen, Users, Calendar } from "lucide-react"

export default function Publications() {
  const publications = [
    {
      title: "Advances in Maternal Healthcare",
      authors: "Dr. Praggya Srivastava, Dr. Jayasri Karem",
      journal: "Journal of Obstetrics & Gynecology",
      year: "2024"
    },
    {
      title: "Pediatric Care Excellence",
      authors: "Dr. Manish Gour",
      journal: "Indian Journal of Pediatrics",
      year: "2024"
    },
    {
      title: "Women's Health Innovations",
      authors: "Pranaam Research Team",
      journal: "Healthcare Innovations Quarterly",
      year: "2023"
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Research Publications</h1>
          <p className="text-lg md:text-xl text-white/90">Contributing to Medical Knowledge</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <img src="/images/HealthcareSpectrum.png" alt="Healthcare" className="w-full h-auto max-h-80 object-contain rounded-lg mb-6" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Our Research Contributions</h2>
          <p className="text-gray-600 mb-6">
            Pranaam Hospitals actively contributes to medical literature through research publications, 
            case studies, and clinical findings. Our team of expert doctors and researchers regularly 
            publish their work in national and international medical journals.
          </p>
        </div>

        <div className="space-y-6">
          {publications.map((pub, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-4 md:p-6">
              <div className="flex flex-col sm:flex-row items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <FileText className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-2">{pub.title}</h3>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                    <div className="flex items-center gap-1">
                      <Users className="w-4 h-4" />
                      <span>{pub.authors}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <BookOpen className="w-4 h-4" />
                      <span>{pub.journal}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      <span>{pub.year}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
